function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-0.5 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 10h2V5h-2v5zm-5 0h2V5H7v5zm10 1.307V2H3v12h4v2.953L9.56 14h4.78L17 11.307zM13.907 17H9.993l-2.606 3H5v-3H0V3.48L1.3 0H19v12.173L13.907 17z",
  fill: "currentColor",
  fillRule: "evenodd"
})));